import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function LatestVideos() {
  const latestVideos = videos.slice(0, 6);

  return (
    <section className="w-full py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 mb-4">
            <i className="ri-timer-flash-line text-accent-600"></i>
            <span className="text-accent-700 text-xs font-semibold">每日更新</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            每日刷新国产黑料
            <span className="text-primary-500">反差视频</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            最新吃瓜爆料视频，网红翻车明星八卦，每日不间断更新中
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/video/${video.id}`}
              className="group relative overflow-hidden rounded-2xl cursor-pointer h-[340px]"
            >
              <img
                src={video.thumbnail}
                alt={video.title}
                title={video.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-500/80 text-background-50">
                    {video.tags[0]}
                  </span>
                  <span className="text-background-300 text-xs">{video.duration}</span>
                </div>
                <h3 className="text-background-50 font-semibold text-base leading-snug mb-1 line-clamp-2">
                  {video.title}
                </h3>
                <p className="text-background-400 text-xs line-clamp-2 leading-relaxed">
                  {video.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">
          <Link
            to="/category/wanghong-fanche"
            className="flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-emotion-sad-line"></i>
            网红翻车合集
          </Link>
          <Link
            to="/category/mingxing-bagua"
            className="flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-800 hover:bg-secondary-200 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-star-line"></i>
            明星八卦专区
          </Link>
          <Link
            to="/category/fancha-shipin"
            className="flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-800 hover:bg-secondary-200 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-contrast-2-line"></i>
            反差视频精选
          </Link>
        </div>
      </div>
    </section>
  );
}